import { KeyResultBinaryChoice, KeyResultType } from "@teaming/common-enums";

// TODO: update these values
/** @deprecated */
export const DefaultKeyResultValues = {
	[ KeyResultType.BINARY ]: () => ( {
		currentValue: KeyResultBinaryChoice.INCOMPLETE,
		goalValue: KeyResultBinaryChoice.COMPLETE,
	} ),
	[ KeyResultType.PERCENTAGE ]: () => ( { currentValue: 0, goalValue: 100, } ),
	[ KeyResultType.CURRENCY ]: () => ( { currentValue: 0, goalValue: "", } ),
	[ KeyResultType.NUMERIC ]: () => ( { currentValue: 0, goalValue: "", } ),
	default: () => ( { currentValue: "", goalValue: "", } ),
};
